export default class ColumnSort {

    constructor () {

        this.typeFilter = '';
        this.hideCompleted = false;
        this.mode = '';
        this.searchTerm = '';
        this.userSecurityId = '';
        this.accountNumber = '';
        this.owner = '';
        this.gridKey = '';
        this.sortColumn = {};
    }
}
